export enum IncidentNibrsLossType {
    Recovered = '5',
    Stolen = '7'
}